<template>
  <div>
    <Header></Header>
    <ModelCards></ModelCards>
  </div>
</template>
<script>
import ModelCards from "../../components/beforeCarShow/modelCards";
export default {
  data() {
    return {
      swiper: null,
    };
  },
  components: {
    ModelCards,
  },
  mounted() {
  },
  methods: {
  },
};
</script>
<style lang="scss" scoped>
</style>